 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLEBB from '@/components/xhtml/ebb'
 import XHTMLARCHIVE from '@/components/xhtml/archive'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE from '@/components/xhtml/01_Title'
 import XHTML02_FM from '@/components/xhtml/02_Fm'
 import XHTMLTOC from '@/components/xhtml/Toc'
 import XHTML03_INTRODUCTION from '@/components/xhtml/03_Introduction'
 import XHTML04_ACK from '@/components/xhtml/04_Ack'
 import XHTML05_CHAPTER01 from '@/components/xhtml/05_Chapter01'
 import XHTML06_CHAPTER011 from '@/components/xhtml/06_Chapter011'
 import XHTML07_CHAPTER012 from '@/components/xhtml/07_Chapter012'
 import XHTML08_CHAPTER013 from '@/components/xhtml/08_Chapter013'
 import XHTML09_CHAPTER02 from '@/components/xhtml/09_Chapter02'
 import XHTML10_CHAPTER021 from '@/components/xhtml/10_Chapter021'
 import XHTML11_CHAPTER022 from '@/components/xhtml/11_Chapter022'
 import XHTML12_CHAPTER023 from '@/components/xhtml/12_Chapter023'
 import XHTML13_CHAPTER024 from '@/components/xhtml/13_Chapter024'
 import XHTML14_CHAPTER025 from '@/components/xhtml/14_Chapter025'
 import XHTML15_CHAPTER026 from '@/components/xhtml/15_Chapter026'
 import XHTML16_CHAPTER027 from '@/components/xhtml/16_Chapter027'
 import XHTML17_CHAPTER028 from '@/components/xhtml/17_Chapter028'
 import XHTML18_CHAPTER029 from '@/components/xhtml/18_Chapter029'
 import XHTML19_CHAPTER0210 from '@/components/xhtml/19_Chapter0210'
 import XHTML20_CHAPTER0211 from '@/components/xhtml/20_Chapter0211'
 import XHTML21_CHAPTER03 from '@/components/xhtml/21_Chapter03'
 import XHTML22_CHAPTER031 from '@/components/xhtml/22_Chapter031'
 import XHTML23_CHAPTER04 from '@/components/xhtml/23_Chapter04'
 import XHTML24_CHAPTER041 from '@/components/xhtml/24_Chapter041'
 import XHTML25_CHAPTER042 from '@/components/xhtml/25_Chapter042'
 import XHTML26_CHAPTER043 from '@/components/xhtml/26_Chapter043'
 import XHTML27_CHAPTER044 from '@/components/xhtml/27_Chapter044'
 import XHTML28_CHAPTER045 from '@/components/xhtml/28_Chapter045'
 import XHTML29_CHAPTER05 from '@/components/xhtml/29_Chapter05'
 import XHTML30_CHAPTER051 from '@/components/xhtml/30_Chapter051'
 import XHTML31_CHAPTER052 from '@/components/xhtml/31_Chapter052'
 import XHTML32_CHAPTER053 from '@/components/xhtml/32_Chapter053'
 import XHTML33_CHAPTER06 from '@/components/xhtml/33_Chapter06'
 import XHTML34_CHAPTER061 from '@/components/xhtml/34_Chapter061'
 import XHTML35_CHAPTER062 from '@/components/xhtml/35_Chapter062'
 import XHTML36_CHAPTER07 from '@/components/xhtml/36_Chapter07'
 import XHTML37_CHAPTER071 from '@/components/xhtml/37_Chapter071'
 import XHTML38_CHAPTER08 from '@/components/xhtml/38_Chapter08'
 import XHTML39_CHAPTER081 from '@/components/xhtml/39_Chapter081'
 import XHTML40_CHAPTER09 from '@/components/xhtml/40_Chapter09'
 import XHTML41_CHAPTER091 from '@/components/xhtml/41_Chapter091'
 import XHTML42_CHAPTER092 from '@/components/xhtml/42_Chapter092'
 import XHTML43_CHAPTER093 from '@/components/xhtml/43_Chapter093'
 import XHTML44_CHAPTER10 from '@/components/xhtml/44_Chapter10'
 import XHTML45_CHAPTER101 from '@/components/xhtml/45_Chapter101'
 import XHTML46_CHAPTER102 from '@/components/xhtml/46_Chapter102'
 import XHTML47_CHAPTER103 from '@/components/xhtml/47_Chapter103'
 import XHTML48_CHAPTER104 from '@/components/xhtml/48_Chapter104'
 import XHTML49_CHAPTER11 from '@/components/xhtml/49_Chapter11'
 import XHTML50_CHAPTER111 from '@/components/xhtml/50_Chapter111'
 import XHTML51_CHAPTER112 from '@/components/xhtml/51_Chapter112'
 import XHTML52_CHAPTER12 from '@/components/xhtml/52_Chapter12'
 import XHTML53_CHAPTER121 from '@/components/xhtml/53_Chapter121'
 import XHTML54_CHAPTER13 from '@/components/xhtml/54_Chapter13'
 import XHTML55_CHAPTER131 from '@/components/xhtml/55_Chapter131'
 import XHTML56_CHAPTER132 from '@/components/xhtml/56_Chapter132'
 import XHTML57_CHAPTER133 from '@/components/xhtml/57_Chapter133'
 import XHTML58_CHAPTER134 from '@/components/xhtml/58_Chapter134'
 import XHTML59_CHAPTER135 from '@/components/xhtml/59_Chapter135'
 import XHTML60_CHAPTER136 from '@/components/xhtml/60_Chapter136'
 import XHTML61_CHAPTER137 from '@/components/xhtml/61_Chapter137'
 import XHTML62_CHAPTER138 from '@/components/xhtml/62_Chapter138'
 import XHTML63_CHAPTER139 from '@/components/xhtml/63_Chapter139'
 import XHTML64_CHAPTER14 from '@/components/xhtml/64_Chapter14'
 import XHTML65_CHAPTER141 from '@/components/xhtml/65_Chapter141'
 import XHTML66_CHAPTER142 from '@/components/xhtml/66_Chapter142'
 import XHTML67_CHAPTER143 from '@/components/xhtml/67_Chapter143'
 import XHTML68_CHAPTER144 from '@/components/xhtml/68_Chapter144'
 import XHTML69_CHAPTER145 from '@/components/xhtml/69_Chapter145'
 import XHTML70_CHAPTER146 from '@/components/xhtml/70_Chapter146'
 import XHTML71_CHAPTER147 from '@/components/xhtml/71_Chapter147'
 import XHTML72_CHAPTER148 from '@/components/xhtml/72_Chapter148'
 import XHTML73_CHAPTER149 from '@/components/xhtml/73_Chapter149'
 import XHTML74_CHAPTER1410 from '@/components/xhtml/74_Chapter1410'
 import XHTML75_CHAPTER1411 from '@/components/xhtml/75_Chapter1411'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLPHILOSOPHICAL from '@/components/xhtml/Philosophical'
 import XHTMLORIMAD from '@/components/xhtml/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Toc",
 			"name" : "xhtml/Toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/03_Introduction",
 			"name" : "xhtml/03_Introduction",
 			"component" : XHTML03_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/04_Ack",
 			"name" : "xhtml/04_Ack",
 			"component" : XHTML04_ACK
 		},
 		{
 			"path" : "/xhtml/05_Chapter01",
 			"name" : "xhtml/05_Chapter01",
 			"component" : XHTML05_CHAPTER01
 		},
 		{
 			"path" : "/xhtml/06_Chapter011",
 			"name" : "xhtml/06_Chapter011",
 			"component" : XHTML06_CHAPTER011
 		},
 		{
 			"path" : "/xhtml/07_Chapter012",
 			"name" : "xhtml/07_Chapter012",
 			"component" : XHTML07_CHAPTER012
 		},
 		{
 			"path" : "/xhtml/08_Chapter013",
 			"name" : "xhtml/08_Chapter013",
 			"component" : XHTML08_CHAPTER013
 		},
 		{
 			"path" : "/xhtml/09_Chapter02",
 			"name" : "xhtml/09_Chapter02",
 			"component" : XHTML09_CHAPTER02
 		},
 		{
 			"path" : "/xhtml/10_Chapter021",
 			"name" : "xhtml/10_Chapter021",
 			"component" : XHTML10_CHAPTER021
 		},
 		{
 			"path" : "/xhtml/11_Chapter022",
 			"name" : "xhtml/11_Chapter022",
 			"component" : XHTML11_CHAPTER022
 		},
 		{
 			"path" : "/xhtml/12_Chapter023",
 			"name" : "xhtml/12_Chapter023",
 			"component" : XHTML12_CHAPTER023
 		},
 		{
 			"path" : "/xhtml/13_Chapter024",
 			"name" : "xhtml/13_Chapter024",
 			"component" : XHTML13_CHAPTER024
 		},
 		{
 			"path" : "/xhtml/14_Chapter025",
 			"name" : "xhtml/14_Chapter025",
 			"component" : XHTML14_CHAPTER025
 		},
 		{
 			"path" : "/xhtml/15_Chapter026",
 			"name" : "xhtml/15_Chapter026",
 			"component" : XHTML15_CHAPTER026
 		},
 		{
 			"path" : "/xhtml/16_Chapter027",
 			"name" : "xhtml/16_Chapter027",
 			"component" : XHTML16_CHAPTER027
 		},
 		{
 			"path" : "/xhtml/17_Chapter028",
 			"name" : "xhtml/17_Chapter028",
 			"component" : XHTML17_CHAPTER028
 		},
 		{
 			"path" : "/xhtml/18_Chapter029",
 			"name" : "xhtml/18_Chapter029",
 			"component" : XHTML18_CHAPTER029
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js